<template>
     
     <v-footer class="bg-transparent text-right">
      <v-row justify="center" no-gutters>
      <span class="text-subtitle-1">&copy; Sibangkom LAN 2024</span>
      </v-row>
    </v-footer>
</template>